import React, { useRef, useState, useEffect } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import { IoHelpCircle } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import {
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Image,
  Input,
  Box,
  HStack,
  VStack,
  Button,
  Icon,
  Grid,
  GridItem,
  Checkbox,
  Tooltip,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";

import { IoTrash } from "react-icons/io5";

import { CustomInputWField } from "../../../../components/CustomInputWField";
import { Group } from "../../Group";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { forNames } from "../../../../utils/masks";

import DadosGeograficosService from "../../../../../main/services/DadosGeograficosService";
import CargaSelecaoService from "../../../../../main/services/CargaSelecaoService";
import { PopoverGenero } from "../../../../components/PopoverGenero";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { format } from "date-fns";

export const Identificacao = ({
  props,
  dataFuturaFoto,
  dataMenorFoto,
  setRemoveu,
  removeu,
}) => {
  const inputRef = useRef();
  const {
    irmaoCadatrar,
    setIrmaoCadatrar,
    idPessoaFisicaFilho,
    setIdPessoaFisicaFilho,
  } = useAppContext();
  const { setFieldValue, values, errors } = useFormikContext();
  const location = useLocation();
  //const urlAarry = location.pathname.split("/");
  const origemNome = new URLSearchParams(location.search).get("nome");
  const origemAcao = new URLSearchParams(location.search).get("acao");
  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [generos, setGeneros] = useState({ options: [], isLoading: false });
  const [racasCores, setRacasCores] = useState({
    options: [],
    isLoading: false,
  });
  const [nacionalidades, setNacionalidades] = useState({
    options: [],
    isLoading: false,
  });
  const [estados, setEstados] = useState({ options: [], isLoading: false });
  const [tiposSanguineos, setTiposSanguineos] = useState({
    options: [],
    isLoading: false,
  });
  const isMobile = useBreakpointValue({ base: true, md: false });
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (values.foto || removeu) {
      setFieldValue("dataFoto", "");
    }
  }, [setFieldValue, values.foto, removeu]);

  useEffect(() => {
    if (
      values.dataNascimento ||
      values.dataNascimento === "" ||
      values.dataMovimentacao ||
      values.dataMovimentacao === ""
    ) {
      setFieldValue("idMotivoSituacao", "");
    }
  }, [values.dataNascimento, setFieldValue, values.dataMovimentacao]);

  useEffect(() => {
    if (irmaoCadatrar && origemAcao) {
      setFieldValue("nome", irmaoCadatrar?.pessoaFisicaIrmao?.nome);

      setFieldValue(
        "dataNascimento",
        irmaoCadatrar?.pessoaFisicaIrmao?.dataNascimento
          ? format(
              new Date(irmaoCadatrar?.pessoaFisicaIrmao?.dataNascimento),
              "dd/MM/yyyy"
            )
          : ""
      );
      setFieldValue("filiacoes", irmaoCadatrar?.filiacoes);
      setIdPessoaFisicaFilho(
        irmaoCadatrar.pessoaFisicaIrmao.idPessoaFisica
          ? irmaoCadatrar.pessoaFisicaIrmao.idPessoaFisica
          : null
      );
    }
  }, [
    setFieldValue,
    irmaoCadatrar,
    setIrmaoCadatrar,
    setIdPessoaFisicaFilho,
    idPessoaFisicaFilho,
    origemAcao,
  ]);
  useEffect(() => {
    setIsOpen(false);
  }, [values?.idGenero]);

  useEffect(() => {
    if (
      values.dataNascimento ||
      values.dataNascimento === "" ||
      values.dataMovimentacao ||
      values.dataMovimentacao === ""
    ) {
      setFieldValue("idMotivoSituacao", "");
    }
  }, [values.dataNascimento, setFieldValue, values.dataMovimentacao]);

  useEffect(() => {
    if (origemNome) {
      setFieldValue("nome", origemNome);
    }
  }, [origemNome, setFieldValue]);

  const fileHandler = (file) => {
    let reader = new FileReader();
    reader.onloadend = () => {
      setFile({
        file: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleGetGeneros = () => {
    setGeneros({ ...generos, isLoading: true });

    CargaSelecaoService.getGeneros().then((res) => {
      const tempOptions = res.data.map((genero) => {
        return {
          id: genero.id,
          label: (
            <HStack justifyContent="space-between">
              <Text
                color="#1A203D"
                fontWeight={400}
                fontSize={{ base: "12px", md: "14px" }}
              >
                {genero.genero}
              </Text>
              <Tooltip
                label={genero.descricao}
                fontSize="md"
                textAlign={"justify"}
                width="90%"
              >
                <span className="hint-tooltip">
                  <Icon
                    aria-label="Aviso de pendente"
                    color="#6B6C71"
                    as={IoHelpCircle}
                    boxSize={{ base: "10px", md: "20px" }}
                  />
                </span>
              </Tooltip>
            </HStack>
          ),
        };
      });
      setGeneros({ options: tempOptions, isLoading: false });
    });
  };

  const handleGetRacasCores = () => {
    setRacasCores({ ...racasCores, isLoading: true });
    CargaSelecaoService.getRacasCores().then((res) => {
      setRacasCores({ options: res.data, isLoading: false });
    });
  };

  const handleGetNacionalidades = () => {
    setNacionalidades({ ...nacionalidades, isLoading: true });
    DadosGeograficosService.getNacionalidades().then((res) => {
      const tempNacionalidade = res.data.find(
        (pais) =>
          pais.descricaoNacionalidade.toUpperCase() === "BRASIL".toUpperCase()
      );
      const newData = res.data.map((item) => {
        const { id, descricaoNacionalidade, ...rest } = item;
        return {
          id,
          nacionalidade: descricaoNacionalidade,
          ...rest,
        };
      });

      setNacionalidades({ options: newData, isLoading: false });
      if (tempNacionalidade) {
        const { id, descricaoNacionalidade, ...rest } = tempNacionalidade;
        const updatedTempNacionalidade = {
          id,
          nacionalidade: descricaoNacionalidade,
          ...rest,
        };
        setFieldValue("idNacionalidade", updatedTempNacionalidade);
      }
    });
  };

  const handleGetEstados = () => {
    setEstados({ ...estados, isLoading: true });
    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  };

  const handleGetTiposSanguineos = () => {
    setTiposSanguineos({ ...tiposSanguineos, isLoading: true });
    CargaSelecaoService.getTiposSanguineos().then((res) => {
      const newData = res.data.map((item) => {
        const { id, nomeTipoSanguineo, ...rest } = item;
        return {
          id,
          tipoSanguineo: nomeTipoSanguineo,
          ...rest,
        };
      });

      setTiposSanguineos({ options: newData, isLoading: false });
    });
  };

  return (
    <Group title="Identificação">
      <Flex
        flexDir={{ base: "column", lg: "row" }}
        w="100%"
        mt="20px"
        alignItems="center"
      >
        <Flex
          w={{ base: "100%", lg: "30%" }}
          alignItems="center"
          justifyContent={"center"}
        >
          <VStack
            alignItems="flex-start"
            border={"solid"}
            borderRadius={"3xl"}
            borderColor={"#CACACA"}
            mr={4}
            px={4}
            py={2}
          >
            <Field name="foto">
              {({ field, form }) => (
                <FormControl
                  isInvalid={form.errors.foto && form.touched.foto}
                  id="foto"
                  d="flex"
                  flexDir="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  {file ? (
                    <Image
                      borderRadius="full"
                      boxSize="135px"
                      src={file.file}
                      alt={file.file.name}
                      fit="cover"
                    />
                  ) : (
                    <Box
                      boxSize="135px"
                      bgColor="#C4C4C4"
                      borderRadius="full"
                    />
                  )}
                  <FormLabel
                    color="#5F6377"
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="19.6px"
                    textAlign="center"
                    htmlFor="foto"
                    m="0px"
                  >
                    Foto Criança/Adolescente
                  </FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    name="foto"
                    id="foto"
                    backgroundColor="#fff"
                    d="none"
                    ref={inputRef}
                    onChange={(event) => {
                      form.setFieldValue(
                        field.name,
                        event.currentTarget.files[0]
                      );
                      fileHandler(event.currentTarget.files[0]);
                    }}
                  />
                  <HStack alignItems="center" mt="5px">
                    <Button
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={500}
                      fontSize="13px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      onClick={() => inputRef.current.click()}
                    >
                      Buscar Imagem
                    </Button>
                    {file && (
                      <Icon
                        aria-label="Excluir imagem"
                        color="#9EA1AE"
                        as={IoTrash}
                        boxSize="25px"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => {
                          setFile(null);
                          setRemoveu(true);
                          form.setFieldValue(field.name, null);
                          inputRef.current.value = "";
                        }}
                      />
                    )}
                  </HStack>
                  <FormErrorMessage>{form.errors.foto}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <CustomDatepickerWField
              fieldName="dataFoto"
              label={`Data da Foto ${values.foto ? "*" : ""} `}
              placeholder="DD/MM/AAAA"
              maxDate={new Date()}
            />

            {dataMenorFoto &&
              props.values.dataNascimento &&
              props.values.dataFoto && (
                <Text
                  mt="8px"
                  color="#E53E3E"
                  fontSize="sm"
                  lineHeight={"normal"}
                >
                  A data da foto não pode ser menor que a data de nascimento.
                </Text>
              )}
            {dataFuturaFoto && props.values.dataFoto && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data informada não pode ser uma data futura!
              </Text>
            )}
          </VStack>
        </Flex>
        <Flex flexDir="column" w="100%">
          <VStack alignItems="flex-start">
            <CustomInputWField
              fieldName="nome"
              label={`Nome ${
                !values.nomeSocial || values.nomeSocial.trim() === "" ? "*" : ""
              } `}
              placeholder="Informe o Nome"
              onChange={(e) => setFieldValue("nome", forNames(e.target.value))}
              isDisabled={values.nomeNaoInformado.length > 0}
            />
            <Flex gap={4}>
              <Field name="nomeFicticio">
                {({ field, form }) => (
                  <FormControl id="nomeFicticio" width="max-content">
                    <Checkbox
                      {...field}
                      value="Possui"
                      name="nomeFicticio"
                      id="nomeFicticio"
                      isChecked={
                        values?.nomeFicticio === true
                          ? true
                          : values?.nomeFicticio === false
                          ? false
                          : values.nomeFicticio?.includes("Possui")
                          ? true
                          : false
                      }
                      whiteSpace="nowrap"
                      onChange={(e) => {
                        const newValue = e.target.checked ? ["Possui"] : [];
                        form.setFieldValue("nomeFicticio", newValue);

                        if (newValue.length > 0) {
                          form.setFieldValue("nomeNaoInformado", []);
                          form.setFieldValue("nomeSocial", "");
                          if (values.nomeNaoInformado.length > 0) {
                            form.setFieldValue("nome", "");
                          }
                        }
                      }}
                    >
                      Nome Fictício
                    </Checkbox>
                    <FormErrorMessage>
                      {form.errors.nomeFicticio}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Field name="nomeNaoInformado">
                {({ field, form }) => (
                  <FormControl id="nomeNaoInformado" width="max-content">
                    <Checkbox
                      {...field}
                      value="Possui"
                      name="nomeNaoInformado"
                      id="nomeNaoInformado"
                      whiteSpace="nowrap"
                      isChecked={
                        values?.nomeNaoInformado === true
                          ? true
                          : values?.nomeNaoInformado === false
                          ? false
                          : values?.nomeNaoInformado?.includes("Possui")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        const newValue = e.target.checked ? ["Possui"] : [];
                        form.setFieldValue("nomeNaoInformado", newValue);
                        if (newValue.length > 0) {
                          form.setFieldValue("nome", "Não Informado");
                          form.setFieldValue("nomeFicticio", []);
                        } else {
                          form.setFieldValue("nome", "");
                        }
                      }}
                    >
                      {`Não Informado${
                        (!form.values.nome || form.values.nome.trim() === "") &&
                        form.values.nomeSocial &&
                        values.nomeSocial.trim() !== ""
                          ? "*"
                          : ""
                      }`}
                    </Checkbox>

                    <Text color="red" opacity={0.8} fontSize="12px">
                      {form.errors.nomeNaoInformado}
                    </Text>
                  </FormControl>
                )}
              </Field>
            </Flex>
          </VStack>
          <CustomInputWField
            fieldName="nomeSocial"
            label={`Nome Social`}
            placeholder="Informe o Nome Social"
            mt="25px"
            onChange={(e) =>
              setFieldValue("nomeSocial", forNames(e.target.value))
            }
            isDisabled={values.nomeFicticio.length > 0}
          />
        </Flex>
      </Flex>
      <Grid mt="15px" templateColumns="repeat(3, 1fr)" gap="25px" rowGap="20px">
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <Flex alignItems={errors.idGenero ? "center" : "end"} gap={2}>
            <CustomSelectWField
              fieldName="idGenero"
              label="Gênero*"
              placeholder="Selecione o Gênero"
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.id}
              isLoading={generos.isLoading}
              options={generos.options}
              onChange={(value) => {
                setFieldValue("idGenero", value);
              }}
              onFocus={generos.options.length === 0 ? handleGetGeneros : null}
            />
            {values.idGenero && isMobile && (
              <PopoverGenero
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                handleClick={handleClick}
                labelTextoGenero={
                  values?.idGenero?.label?.props?.children[1]?.props?.label
                }
              />
            )}
          </Flex>
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <VStack alignItems="flex-start">
            <CustomDatepickerWField
              fieldName="dataNascimento"
              label="Data de Nascimento*"
              placeholder="DD/MM/AAAA"
            />
            <Field name="dataNascimentoEstimada">
              {({ field, form }) => (
                <FormControl id="dataNascimentoEstimada" width="max-content">
                  <Checkbox
                    {...field}
                    value="Possui"
                    name="dataNascimentoEstimada"
                    id="dataNascimentoEstimada"
                    whiteSpace="nowrap"
                  >
                    Data de Nascimento Estimada
                  </Checkbox>
                  <FormErrorMessage>
                    {form.errors.dataNascimentoEstimada}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </VStack>
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="idRaca"
            label="Raça/Cor*"
            placeholder="Selecione a Raça/Cor"
            getOptionLabel={(option) => option.raca}
            getOptionValue={(option) => option.id}
            isLoading={racasCores.isLoading}
            options={racasCores.options}
            onChange={(value) => {
              setFieldValue("idRaca", value);
            }}
            onFocus={
              racasCores.options.length === 0 ? handleGetRacasCores : null
            }
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="idNacionalidade"
            label="Nacionalidade"
            placeholder="Selecione a Nacionalidade"
            getOptionLabel={(option) => option.nacionalidade}
            getOptionValue={(option) => option.id}
            isLoading={nacionalidades.isLoading}
            options={nacionalidades.options}
            onChange={(value) => {
              if (!!value) {
                if (value.nacionalidade !== "BRASIL") {
                  setFieldValue("idNaturalidade", "");
                }
              }
              setFieldValue("idNacionalidade", value);
            }}
            onFocus={
              nacionalidades.options.length === 0
                ? handleGetNacionalidades
                : null
            }
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="idNaturalidade"
            label="Naturalidade"
            placeholder="Informe a Naturalidade"
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            isLoading={estados.isLoading}
            options={estados.options}
            onChange={(value) => {
              setFieldValue("idNaturalidade", value);
            }}
            onFocus={estados.options.length === 0 ? handleGetEstados : null}
            isDisabled={
              !!values.idNacionalidade
                ? values.idNacionalidade.nacionalidade !== "BRASIL"
                : false
            }
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="idTipoSanguineo"
            label="Tipo Sanguíneo"
            placeholder="Selecione o Tipo Sanguíneo"
            getOptionLabel={(option) => option.tipoSanguineo}
            getOptionValue={(option) => option.id}
            isLoading={tiposSanguineos.isLoading}
            options={tiposSanguineos.options}
            onChange={(value) => {
              setFieldValue("idTipoSanguineo", value);
            }}
            onFocus={
              tiposSanguineos.options.length === 0
                ? handleGetTiposSanguineos
                : null
            }
          />
        </GridItem>
      </Grid>
    </Group>
  );
};
